(function () {
  'use strict';

  angular.module('ringbaPortal').component('changelogDetails', {
    controller: ChangelogDetailsController,
    bindings: {
      changelog: '<',
      changelogRelatedActions: '<',
      showInRelatedActions: '<',
      hideDetails: '&',
      wide: '<'
    },
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/changelog/changelog-details/changelog-details.view.html'
  });

  function ChangelogDetailsController(
    changelogDeltaService
  ) {
    'ngInject';

    const vm = this;

    vm.viewData = {
      actionClass: '',
      actionText: ''
    };

    vm.$onChanges = onChanges;
    vm.showChangelogDetails = showChangelogDetails;

    function onChanges() {
      if (vm.changelog) {
        vm.viewData = changelogDeltaService.getActionViewData(vm.changelog);
        vm.statement = changelogDeltaService.getActionStatement(vm.changelog);
      }
    }

    function showChangelogDetails(log) {
      if (log.action !== 'Create') {
        log.showDetails = !log.showDetails;
      }
    }

  }
})();
